module.exports = __webpack_public_path__ + "web/img/审核驳回.522981b3.png";